import { createFileRoute } from '@tanstack/react-router'
import { getBootstrapWorkspaceRefs } from '@/features/bootstrap/domain/bootstrap-workspaces'
import { useBootstrapQuery } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { getPreferredWorkspaceRoute } from '@/features/chats/domain/use-workspace-chat-shell-domain'
import { WorkspaceChatShellPage } from '@/pages/workspace/workspace-chat-shell'
import WorkspaceEmptyPage from '@/pages/workspace/workspace-empty'
import { requireAuthenticated } from '@/shared/lib/route-guards'

interface McpAuthorizeSearchParams {
  mcp_consent?: string
  mcp_client_name?: string
}

function McpAuthorizeRoutePage() {
  const bootstrapQuery = useBootstrapQuery()
  const workspaces = getBootstrapWorkspaceRefs(
    bootstrapQuery.data?.workspaces ?? [],
  )
  const workspaceId = getPreferredWorkspaceRoute(workspaces)

  return workspaceId ? (
    <WorkspaceChatShellPage workspaceId={workspaceId} chatId={null} />
  ) : (
    <WorkspaceEmptyPage />
  )
}

export const Route = createFileRoute('/$lang/mcp/authorize')({
  validateSearch: (
    search: Record<string, unknown>,
  ): McpAuthorizeSearchParams => ({
    mcp_consent:
      typeof search.mcp_consent === 'string' ? search.mcp_consent : undefined,
    mcp_client_name:
      typeof search.mcp_client_name === 'string'
        ? search.mcp_client_name
        : undefined,
  }),
  beforeLoad: ({ context, params, location }) => {
    requireAuthenticated(context, params, location.href)
  },
  component: McpAuthorizeRoutePage,
  staticData: { layout: 'main' },
})
